export enum EnumTipoFactura {
  Generada = 1,
  Proforma,
  Recibida,
  Simulada,
  Albaran,
  Recapitulativa,
  Resumen,
  Manual
}
